import { ViewTopicCommunityModel } from 'functions/app/topic-community/view'
import { KnowledgeHubModulesSection } from '@app/components/blocks/KnowledgeHubModulesSection'

export const TopicCommunityPageKnowledgeHub = ({
  topicCommunity,
}: {
  topicCommunity: ViewTopicCommunityModel
}) => (
  <KnowledgeHubModulesSection
    modules={topicCommunity?.knowledgeHubModules ?? []}
  />
)
